// True only in the static export build (REACT_APP_STATIC_EXPORT=true).
// In static mode the site runs with no backend: blog posts come from baked
// build-time data and the contact form falls back to the visitor's email app.
export const STATIC_EXPORT = process.env.REACT_APP_STATIC_EXPORT === "true";
